import { Controller } from "@hotwired/stimulus"

// Reports a tap on a link that leaves for the App Store. The link keeps its
// own href and target; this only counts the tap, so the report must not block
// or alter navigation. keepalive lets the request outlive the page.
export default class extends Controller {
  static values = { url: String }

  track() {
    if (!this.hasUrlValue) return

    fetch(this.urlValue, {
      method: "POST",
      keepalive: true,
      headers: { "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content || "" }
    }).catch(() => {})
  }
}
